<template>
    <div :id="this.id" @contextmenu.prevent="handler($event)"
         class="sitebuilder-element-container"
         element="Image3DComponent"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         :style="style()" @click="linkAction()">

        <img ref="image" :src="this.internal_config.src"
             alt="" class="sitebuilder-element image3d-element img3D"
             v-bind:style="{opacity: opacity}">
    </div>

</template>

<script>

	import ImageData from './Model';

	export default {
		name: 'Image3DComponent',
		props: ['config', 'src', 'id', 'preview', 'device'],
		components: {
			ImageData,
		},
		computed: {
			opacity() {
				return this.internal_config.opacity;
			},
		},
		data() {
			return ImageData.data();
		},
		methods: {

			animation() {
				return true;
			},
			linkAction: function () {


				// if (this.internal_config.link.type === 'video' && this.internal_config.link.value !== '') {
				//   this.$refs.videoModalIframe.src = this.internal_config.link.value;
				//   this.$refs.videoModal.open();
				// } else {
				this.$root.$emit('linkAction', this.internal_config.link);
				// }

			},
			build(config) {
				this.internal_config = config;
			},
			style() {
				var style = `width: ${this.internal_config.width};
                     height:  auto;
                     z-index: ${this.internal_config.zIndex};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     margin-left: ${this.internal_config.marginLeft};
                     margin-right: ${this.internal_config.marginRight};
                     left:  ${this.internal_config.left};
										 top: ${this.internal_config.top};
										 transform: rotate(${this.$props.device == 'desktop' ? this.internal_config.rotation : 0}) scale(1) `;
				return style;
			},
		},
		mounted() {

			this.build(this.$props.config);

			this.internal_config = window.mergeRecursive(this.props, this.$props.config);
			this.internal_config.src = this.internal_config.src.replace('omb11.com', 'storage.builderall.com');

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
			
			let vm = this;
			setTimeout(function () {
				$(vm.$refs.image).atvImg();
			}, 2000);

		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    img {
        width: 100%;
        height: auto !important;
    }

    .resizable.vdr {
        width: 100% !important;
        height: auto !important;
        left: 0 !important;
        top: 0 !important;
    }
</style>
